import React from 'react'
import { i18n } from '@/locale/i18n'
import { Crevron } from '@/assets/icons'
import { WAGER_STATUS } from '@/constants/marketBackendEnums'

/**
 * A list row's way into its open wagers: a chip holding the count the card footer reports,
 * spelled out ("1 bet") with a chevron, expanding the very bet list the card would show.
 * Nothing renders when the user holds no open position on the market, so it doubles as the
 * row's only sign that they do.
 *
 * Shared by the market row and the fixture row: the two lists sit under the same toggle
 * and should answer "do I have money on this one" identically.
 */
const RowBetCountToggle = ({ question, open = false, onToggle, cellClassName = '' }) => {
  /* Counted exactly as the card footer counts it, so a row and a card never disagree
     about how many bets a user has on a market. */
  const betCount = (question?.wagers || []).filter(wager => wager.status === WAGER_STATUS.PURCHASE).length
  if (betCount === 0) return null

  /* The cell is the component's own, so a row with no open position renders nothing at
     all — an empty wrapper would still take one of the row's 16px gaps. */
  return (
    <div className={`flex shrink-0 items-center ${cellClassName}`}>
      <button
        type="button"
        onClick={event => {
          event.stopPropagation()
          onToggle?.()
        }}
        aria-expanded={open}
        title={open ? i18n('question_card.hide_bets') : i18n('question_card.show_bets')}
        className="inline-flex h-5 shrink-0 cursor-pointer items-center gap-0.5 rounded-full border-none bg-surface-3 pl-2 pr-1 text-xs leading-none text-Neutral-6 transition-colors hover:bg-Neutral-3">
        <span className="tabular-nums">
          {i18n(betCount === 1 ? 'markets.bet_count_one' : 'markets.bet_count_other', { count: betCount })}
        </span>
        {/* Crevron sets its own transform for `direction`, which cannot be transitioned;
            the rotation lives on the wrapper instead. */}
        <span
          className={`inline-flex h-3 w-3 items-center justify-center transition-transform duration-200 ${
            open ? 'rotate-180' : ''
          }`}>
          <Crevron width="10px" height="10px" fillcolor="currentColor" />
        </span>
      </button>
    </div>
  )
}

export default RowBetCountToggle
